import {BannerAction, BannerSize, BannerTheme} from 'common/components/banner/types';

import {ReportBanner} from './types';

/**
 * Be sure to keep this in sync with the backend that is redirecting
 * e.g. for slack query params, they are set in slack > views.py > slack_oauth_redirect
 */
export enum RedirectBannerUrlParams {
  SlackFail = `slack-fail`,
  SlackSuccess = `slack-success`,
  SlackCancel = `slack-cancel`,
}

const dismissCta = {
  text: `Dismiss`,
  actionName: BannerAction.Dismiss,
};

export const enum BannerEventNames {
  BannersShown = `[Report Banners] Banners shown`,
  BannerShown = `[Report Banners] Banner shown`,
  BannerHidden = `[Report Banners] Banner hidden`,
}

export const enum BannerEventProps {
  NumBannersShown = `num banners shown`,
  BannerType = `banner type`,
  BannerMessage = `banner message`,
  BannerName = `banner name`,
  BannerTitle = `banner title`,
  ReportName = `report name`,
  ProjectId = `project id`,
  WorkspaceId = `workspace id`,
}

export const REDIRECT_BANNERS: {[key in RedirectBannerUrlParams]: ReportBanner} = {
  [RedirectBannerUrlParams.SlackFail]: {
    ctas: [dismissCta],
    name: RedirectBannerUrlParams.SlackFail,
    size: BannerSize.Small,
    message: `Something went wrong connecting to Slack`,
    type: BannerTheme.Error,
    visible: true,
  },
  [RedirectBannerUrlParams.SlackSuccess]: {
    ctas: [dismissCta],
    name: RedirectBannerUrlParams.SlackSuccess,
    size: BannerSize.Small,
    message: `Successfully connected with Slack`,
    type: BannerTheme.Success,
    visible: true,
  },
  [RedirectBannerUrlParams.SlackCancel]: {
    ctas: [dismissCta],
    name: RedirectBannerUrlParams.SlackCancel,
    size: BannerSize.Small,
    message: `Slack authentication canceled`,
    type: BannerTheme.Info,
    visible: true,
  },
};
